export const departmentList = {
    dept100 : 1, // Owner
    dept200 : 2, // Admin
    dept400 : 3, // Sales
    dept750 : 4, // Chips
    dept900 : 5 // 1099
};
